import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large ActNumber",
    title: "Изменить номер АВР",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitToggle,
    onConfirm: _ctx.changeActNumber,
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_the_input, {
          value: _ctx.payload.actNumber,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.actNumber) = $event)),
          "is-invalid": _ctx.state_form$.actNumber.$error,
          "validation-errors": _ctx.state_form$.actNumber.$errors,
          placeholder: "Номер АВР"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_button, {
          class: "primary small text ml-2 mt-2 py-3",
          disabled: _ctx.state.is_loading,
          onClick: _ctx.addOrder
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payload.ftlOrderIds, (order, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `order-${i}`,
          class: "flex items-center mt-2"
        }, [
          _createVNode(_component_the_input, {
            value: _ctx.payload.ftlOrderIds[i],
            "onUpdate:value": ($event: any) => ((_ctx.payload.ftlOrderIds[i]) = $event),
            placeholder: "FTL заказ",
            "is-invalid": !_ctx.payload.ftlOrderIds[i]
          }, null, 8, ["value", "onUpdate:value", "is-invalid"]),
          _createVNode(_component_the_button, {
            class: "red small text ml-2 mt-2 py-3",
            disabled: _ctx.state.is_loading,
            onClick: ($event: any) => (_ctx.deleteOrder(i))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}